<template>
    <div class="container-list">
        <div class="common-page common-head">
            <div class="common-page common-head-title">
                <i class="icon-tr-other" style="padding-right: 5px"></i>
                权限添加
            </div>
        </div>
        <el-form ref="form" :model="form" label-width="110px" :rules="rules">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="权限名称" prop="menu_name">
                        <el-input v-model="form.menu_name" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="权限类型" prop="menu_type">
                        <el-select v-model="form.menu_type" placeholder="请选择权限类型">
                            <el-option v-for="(key,item) in $map.roleType" :label="key" :value="+item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="链接">
                        <el-input v-model="form.menu_href" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="父菜单" prop="father_menu_key">
                        <!--  <el-select v-model="form.father_menu_key" placeholder="请选择父菜单">
                           <el-option v-for="(key,item) in $map.roleType" :label="key" :value="item"></el-option>
                        </el-select>-->
                        <el-input v-model="form.father_menu_key" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="按钮标记名称" prop="func_tag">
                        <el-input placeholder="请输入" v-model="form.func_tag"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="菜单排序" prop="menu_sort">
                        <el-input placeholder="请输入" v-model="form.menu_sort"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="btn-box">
                <div class="l-btn" @click="onSubmit">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div>

        </el-form>
    </div>
</template>

<script>
    import {addmenu} from '../../api/menu'
    export default {
        data(){
            return{
                form:{
                    menu_name: '',
                    menu_href:'',
                    menu_type: '',
                    father_menu_key:'',
                    func_tag:'',
                    menu_sort:'',
                    "method": "2",
                    "status": "1",
                    
                },
                rules: {

                }
            }
        },
        created(){

            if(this.$route.query.id){
                this.$post('/menu/findbyid',{id:this.$route.query.id}).then(res=>{
                    this.form = res.data
                })
            }
        },
        methods:{
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.save()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            save(){
                let loading = this.$loading({background: 'rgba(0, 0, 0, 0.6)'})
                let api = this.$route.query.id ? '/menu/update' : '/menu/add';
                this.$post(api,this.form).then(res=>{
                    // this.$message.success('保存成功')
                    this.$message({
									message: "保存成功",
									type: 'success',
									duration: 700,
								});
                    this.$router.back()
                    loading.close()
                }).catch(err=>{
                    loading.close()
                })

            }
        }
    }
</script>

<style scoped>

</style>
